/* eslint-disable indent */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Icon,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  CircularProgress,
  ListSubheader,
  Divider,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Tooltip,
  Collapse,
} from '@mui/material';
import {
  CheckBox,
  ContentCopy,
  ExpandLess,
  ExpandMore,
  Update,
} from '@mui/icons-material';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  patchEvent,
  changeStatus,
  getEvent,
} from '@pingum/app-state-management/event/actions';
import { editEventStatus } from '@pingum/app-state-management/eventStatus/actions';
import { LoadingButton } from '@mui/lab';
import { MobileDatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import {
  addScheduleException,
  deleteSchedule,
  updateSchedule,
} from '../../../redux/schedule/actions';
import { setGlobalModals } from '../../../redux/app/actions';
import { SCHEDULE_MODAL_TYPE } from '../../../redux/app/types';
import {
  getBarnUsersForAssignmentString,
  getScheduleExceptionScheduleReplacementObject,
  getScheduleSeriesText,
} from '../../../utils/scheduleHelper';
import TagList from '../../TagList';
import BarnUsersAutocomplete from '../../Autocompletes/BarnUsers';

export class EventActionsMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      element: null,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      copyTask: false,
      dialogType: 'more',
    };
  }

  handleOpen = (e, dialogType) => {
    this.setState({
      open: true,
      element: e.currentTarget,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      dialogType,
      copyTask: false,
    });
  }

  handleClose = (reload) => {
    // If there as a callback, call here first
    if (reload && this.props.modalCallback) {
      this.props.modalCallback()
    }
    this.setState({
      open: false,
      element: null,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      dialogType: 'more',
      copyTask: false,
    });
    if (reload && this.props.selectedEvent && this.props.selectedEvent.id) {
      this.props.getEvent(this.props.selectedEvent.id)
    }
    this.props.onClose();
  }

  handleArchiveEvent = (request) => {
    this.props.patchEvent(this.props.selectedEvent.id, request);
    this.handleClose();
  }

  handleEventStatus = (request) => {
    this.props.patchEvent(this.props.selectedEvent.id, request).then(() => {
      const statusId = request.completeEvent
        ? this.props.selectedBarn.barnMetadata.statusEndId
        : this.props.selectedBarn.barnMetadata.statusPendingId;
      this.handleClose();
      this.props.changeStatus(this.props.selectedEvent.id, {
        statusId: parseInt(statusId, 10),
        statusComment: null,
        completeEvent: request.completeEvent,
        assignment: (this.props.selectedEvent.currentEventStatus && this.props.selectedEvent.currentEventStatus.assignment) || '',
      })
    });
  }

  handleConfirmDeleteOccurrence = () => {
    const isSingleOccurrence = this.props.selectedSchedule && !this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.endDate
      && new Date(this.props.selectedSchedule.startDate).getTime() === new Date(this.props.selectedSchedule.endDate).getTime()
    const isScheduleException = this.props.selectedSchedule
      && this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id;
    const hasMultipleTasksOrWorkflows = this.props.selectedSchedule
      && (this.props.eventTasks.length > 1 || this.props.selectedSchedule.workflows > 1);
    const onlyRemoveSelectedTask = hasMultipleTasksOrWorkflows && !this.state.deleteOtherTasks;

    // No schedule associated so just archive this event
    if (!this.props.selectedSchedule || !this.props.selectedSchedule.id) {
      this.props.patchEvent(this.props.selectedEvent.id, { archived: true }).then(() => {
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
        this.handleClose();
      });
    } else if ((isSingleOccurrence || isScheduleException) && !onlyRemoveSelectedTask) {
      // We can delete the entire schedule
      this.props.deleteSchedule(this.props.selectedSchedule.id).then(() => {
        // If there as a callback, call here first
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if ((isScheduleException || isSingleOccurrence) && onlyRemoveSelectedTask && this.props.selectedEvent) {
      // We are only removing one task/workflow from a group of multiple
      // TODO right now we only allow this on created events (not future/scheduled)
      this.props.updateSchedule(this.props.selectedSchedule.id, {
        workflows: this.props.selectedSchedule.workflows
          .filter((w) => !w.tagIds.some((t) => this.props.selectedEvent.tags.map((tt) => tt.id).includes(t))),
      }).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if ((!isSingleOccurrence && !isScheduleException) && !onlyRemoveSelectedTask) {
      // Add schedule exception to cancel occurrence
      this.props.addScheduleException(this.props.selectedSchedule.id, {
        exceptionDate: new Date((this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start)
          ? this.props.selectedScheduleEvent.start
          : this.props.selectedEvent.startDate),
        reason: 'Canceled occurrence',
      }).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete this schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if (!isSingleOccurrence && !isScheduleException && onlyRemoveSelectedTask && this.props.selectedEvent) {
      // Add schedule exception to remove single workflow
      this.props.addScheduleException(this.props.selectedSchedule.id, {
        exceptionDate: this.props.selectedEvent.startDate,
        reason: 'Rescheduled occurrence',
        exceptionSchedule: {
          ...getScheduleExceptionScheduleReplacementObject((this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start)
            ? this.props.selectedScheduleEvent.start
            : this.props.selectedEvent.startDate, this.props.selectedSchedule),
          workflows: this.props.selectedSchedule.workflows
            .filter((w) => !w.tagIds.some((t) => this.props.selectedEvent.tags.map((tt) => tt.id).includes(t))),
        },
      }).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete this schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    }
  };

  handleConfirmDeleteSeries = () => {
    this.props.deleteSchedule((this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id)
      || this.props.selectedSchedule.id).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
  }

  handleConfirmEndSeries = () => {
    this.props.updateSchedule(
      (this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id) || this.props.selectedSchedule.id,
      {
        endDate: (this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start
          && moment(this.props.selectedScheduleEvent.start).add('-1', 'hours').toDate()) || new Date(),
      },
    ).then(() => {
      this.handleClose(true);
      this.props.setGlobalModals(null, null, null, null, {}, () => { });
    }).catch((error) => {
      alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
      console.error(error);
    });
  }

  copyDateClick = (newValue) => {
    const startDate = this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start;
    const ogDate = moment(startDate);
    const rescheduleDate = moment(newValue.toDate()).add(ogDate.hours(), 'hours').add(ogDate.minutes(), 'minutes').toDate();

    let locationId = null;
    // need to find the location so we can open the calendar event modal
    const locationTag = (this.props.selectedEvent.tags
      || this.props.selectedSchedule.tags).find((t) => t.tagType.id === this.props.selectedBarn.barnMetadata.locationTagTypeId)
    const eventTypeTag = (this.props.selectedEvent.tags
      || this.props.selectedSchedule.tags).find((t) => t.id === this.props.selectedBarn.barnMetadata.eventTaskTypeTagId)
    locationId = (eventTypeTag && (locationTag && locationTag.id)) || null;
    this.props.setGlobalModals(
      SCHEDULE_MODAL_TYPE,
      null,
      this.props.selectedSchedule,
      this.props.selectedScheduleEvent,
      {
        locationId, // if set, this is a calendar event
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: false,
        startDate: null,
        assignment: null,
        rescheduleDate,
      },
      () => { },
    );
    this.setState({ open: false })
  }

  render() {
    const {
      selectedEvent,
      selectedSchedule,
      selectedScheduleEvent,
      eventTasks,
      isUpdatingEvent,
      isFetchingSchedules,
      selectedBarn,
      sx,
      attachFileClick,
      permissions,
      flexDirection,
      showMore,
    } = this.props;
    const { copyTask } = this.state;

    const selectedOccurrenceDate = (selectedScheduleEvent && selectedScheduleEvent.start) || (selectedEvent && selectedEvent.start)
    const isCalendarEvent = (selectedScheduleEvent && selectedScheduleEvent.eventTask)
      || (selectedSchedule && selectedSchedule.tags && !!selectedSchedule.tags.find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId))
    const entityTerm = `${(!selectedEvent || !selectedEvent.id)
      ? 'Future '
      : ''}${isCalendarEvent || (selectedScheduleEvent && selectedScheduleEvent.eventTask)
        ? 'Calendar Event'
        : 'Task'}`
    const scheduleSeriesText = selectedSchedule && selectedSchedule.id && getScheduleSeriesText(selectedSchedule);
    const resourceType = (selectedScheduleEvent && selectedScheduleEvent.horseTask && 'horse')
      || (selectedScheduleEvent && selectedScheduleEvent.horseTask && 'chore') || 'task'

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection,
        }}
      >
        {
          (isUpdatingEvent || isFetchingSchedules) && (<CircularProgress size={30} sx={sx} />)
        }
        {
          ((!this.props.editMode && !isUpdatingEvent && !isFetchingSchedules) && selectedEvent && selectedEvent.id && this.props.onEdit) && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); this.props.onEdit(e); }}
              id="menu-btn"
              aria-owns={this.state.open
                ? 'menu-appbar'
                : null}
              aria-haspopup="true"
            >
              <Icon sx={sx}>edit</Icon>
            </IconButton>
          )
        }
        {
          !(isUpdatingEvent || isFetchingSchedules) && (
            <Tooltip title="Delete Task" placement="left" disableInteractive>
              <IconButton
                onClick={(e) => { e.stopPropagation(); this.handleOpen(e, 'delete'); }}
                id="menu-btn"
                aria-owns={this.state.open
                  ? 'menu-appbar'
                  : null}
                aria-haspopup="true"
              >
                <Icon sx={sx}>delete</Icon>
              </IconButton>
            </Tooltip>
          )
        }
        {
          !(isUpdatingEvent || isFetchingSchedules) && showMore && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); this.handleOpen(e, 'more'); }}
              id="menu-btn"
              aria-owns={this.state.open
                ? 'menu-appbar'
                : null}
              aria-haspopup="true"
            >
              <Icon sx={sx}>more_vert</Icon>
            </IconButton>
          )
        }
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: -10,
            left: 0,
          }}
          open={this.state.open && this.state.dialogType === 'more'}
          onClose={(e) => { e.stopPropagation(); this.handleClose(); }}
        >

          <ListSubheader>Actions</ListSubheader>
          {
            selectedEvent && attachFileClick && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  attachFileClick();
                  this.handleClose();
                }}
              >
                <ListItemIcon>
                  <Icon>cloud_upload</Icon>
                </ListItemIcon>
                Attach File to this Task
              </MenuItem>
            )
          }

          {
            selectedSchedule && selectedSchedule.id && (
              <Divider sx={{ my: 1 }} />
            )
          }
          {
            selectedSchedule && selectedSchedule.id && selectedScheduleEvent && selectedScheduleEvent.id && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); this.setState({ copyTask: !copyTask });
                }}
              >
                <ListItemIcon>
                  <ContentCopy />
                </ListItemIcon>
                <Tooltip title={`Select a date to Copy this ${entityTerm.replace('Future ', '')}`} sx={{ flex: 1 }}><Box>Copy {entityTerm.replace('Future ', '')}</Box></Tooltip>
                {
                  !copyTask
                    ? <ExpandMore color="secondary" />
                    : <ExpandLess color="secondary" />
                }
              </MenuItem>
            )
          }

          <Collapse in={copyTask}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                m: 2,
              }}
            >
              <Box sx={{ mr: 2 }}>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mb: 0.5 }}
                  onClick={(e) => {
                    e.stopPropagation(); this.copyDateClick(moment().startOf('day'))
                  }}
                >Today
                </Button>
              </Box>
              <Box sx={{ mr: 2 }}>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mb: 0.5 }}
                  onClick={(e) => {
                    e.stopPropagation(); this.copyDateClick(moment().add(1, 'days').startOf('day'))
                  }}
                >Tomorrow
                </Button>
              </Box>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileDatePicker
                  label="Choose Date"
                  value={moment().startOf('day')}
                  minDate={new Date()}
                  onChange={this.copyDateClick}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      helperText=""
                      size="small"
                      sx={{
                        maxWidth: 175,
                        ml: 2,
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Collapse>

          <Divider sx={{ my: 1 }} />

          {(selectedEvent && selectedEvent.id && !selectedEvent.archived) && (
            <Box>
              {
                selectedEvent.completeDate
                  ? (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation(); this.handleEventStatus({ completeEvent: false });
                      }}
                    >
                      <ListItemIcon>
                        <Update />
                      </ListItemIcon>
                      Mark Uncomplete
                    </MenuItem>
                  )
                  : (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation(); this.handleEventStatus({ completeEvent: true });
                      }}
                    >
                      <ListItemIcon>
                        <CheckBox color="primary" />
                      </ListItemIcon>
                      Mark Complete
                    </MenuItem>
                  )
              }
            </Box>
          )}

          {
            selectedEvent && selectedEvent.archived && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); this.handleArchiveEvent({ archived: false });
                }}
              >
                <ListItemIcon>
                  <Icon>restore_from_trash</Icon>
                </ListItemIcon>
                Restore Task
              </MenuItem>
            )
          }

          {
            (permissions.owner || permissions.admin) && (
              <Divider sx={{ my: 1 }} />
            )
          }
          {
            (permissions.owner || permissions.admin) && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); window.location.href = `/settings/${(isCalendarEvent && 'calendar') || 'tasks'}/${(selectedEvent && selectedEvent.eventTemplateId) || (selectedSchedule && selectedSchedule.eventTemplate && selectedSchedule.eventTemplate.id)}`;
                }}
              >
                <ListItemIcon>
                  <Icon>settings</Icon>
                </ListItemIcon>
                Manage {entityTerm.replace('Future ', '')} Type Settings
              </MenuItem>
            )
          }

        </Menu>
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: -10,
            left: 0,
          }}
          open={this.state.open && this.state.dialogType === 'assignment'}
          onClose={(e) => { e.stopPropagation(); this.handleClose(); }}
        >
          <Box sx={{ width: 300 }}>
            <BarnUsersAutocomplete
              label="Task Assignment"
              id="barn-users-task-options-autocomplete-assignment"
              multiple
              autoFocus
              blurOnSelect={!((selectedEvent && selectedEvent.currentEventStatus && selectedEvent.currentEventStatus.assignment))}
              size="small"
              value={getBarnUsersForAssignmentString((selectedEvent && selectedEvent.currentEventStatus && selectedEvent.currentEventStatus.assignment) || '', {})}
              onSelect={(e, newBarnUsers) => {
                const newAssignment = newBarnUsers.map((bu) => (bu.id
                  ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                  : `@[${bu.userFullName || bu}](${null})`)).join('');
                // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                this.handleNewAssignment(newAssignment)
              }}
              limitTags={5}
            // suggestAssignmentHorseTagId,
            // suggestParticipantHorseTagId,
            />
          </Box>
        </Menu>
        <Dialog
          open={this.state.open && this.state.dialogType === 'delete'}
          onClose={(e) => {
            e.stopPropagation();
            this.setState({
              open: false,
              confirmCancelOccurrence: false,
              confirmCancelSeries: false,
              confirmEndSeries: false,
              dialogType: 'more',
            })
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Delete {entityTerm} {selectedOccurrenceDate && `(${moment(selectedOccurrenceDate).format('ll')})`}
          </DialogTitle>
          <DialogContent sx={{ minWidth: 300 }}>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {
                  !(eventTasks.length && eventTasks.length > 1) && (
                    <Box sx={{ ml: 1 }}>
                      <TagList
                        tags={((selectedEvent && selectedEvent.tags) || (selectedSchedule && selectedSchedule.tags) || [])
                          .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                            || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                      />
                    </Box>
                  )
                }
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={(
                    <Radio
                      checked={this.state.confirmCancelOccurrence}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          confirmCancelOccurrence: true,
                          confirmCancelSeries: false,
                          confirmEndSeries: false,
                        })
                      }}
                    />
                  )}
                  label={`This ${isCalendarEvent
                    ? 'calendar event'
                    : 'task'}${scheduleSeriesText
                      ? ' occurrence'
                      : ''}`}
                />

                {
                  scheduleSeriesText && (
                    <FormControlLabel
                      sx={{ m: 0 }}
                      control={(
                        <Radio
                          checked={this.state.confirmEndSeries}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              confirmCancelOccurrence: false,
                              confirmCancelSeries: false,
                              confirmEndSeries: true,
                            })
                          }}
                        />
                      )}
                      label={`This and following ${isCalendarEvent
                        ? 'calendar events'
                        : 'tasks'}`}
                    />
                  )
                }
                {
                  scheduleSeriesText && (
                    <FormControlLabel
                      sx={{ m: 0 }}
                      control={(
                        <Radio
                          checked={this.state.confirmCancelSeries}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              confirmCancelOccurrence: false,
                              confirmCancelSeries: true,
                              confirmEndSeries: false,
                            })
                          }}
                        />
                      )}
                      label={`All ${isCalendarEvent
                        ? 'calendar events'
                        : 'tasks'}`}
                    />
                  )
                }
              </RadioGroup>
              <FormHelperText>
                {this.state.confirmCancelSeries && (
                  `All occurrences of this ${resourceType} will be deleted. This Action cannot be undone.`
                )}
                {this.state.confirmEndSeries && (
                  `The repeating ${resourceType} series will end ${moment((this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start
                    && moment(this.props.selectedScheduleEvent.start).toDate()) || new Date()).format('ll')}. Previous ${entityTerm.replace('Future ', '')}s will remain but future scheduled ${entityTerm.replace('Future ', '')}s will be removed.`
                )}
              </FormHelperText>
            </FormControl>

            {
              eventTasks.length && eventTasks.length > 1
                ? (
                  <Box sx={{ m: 2 }}>
                    <Alert severity="info">
                      {eventTasks.length - 1} other {resourceType}{eventTasks.length === 2
                        ? ' was '
                        : 's were '} planned along with this {resourceType}. How would
                      you like to proceed with your delete request?
                    </Alert>

                    <FormControl sx={{ ml: 2 }}>
                      <RadioGroup
                        aria-labelledby="radio-other-tasks-group-label"
                        name="radio-buttons-other-tasks-group"
                        value={this.state.deleteOtherTasks}
                        onChange={(e) => {
                          this.setState({ deleteOtherTasks: e.target.value })
                        }}
                      >
                        <FormControlLabel
                          sx={{ m: 0 }}
                          value={false}
                          control={(<Radio size="small" />)}
                          label={`Only this ${resourceType}`}
                        />
                        <Box sx={{ ml: 4 }}>
                          <TagList
                            tags={((selectedEvent && selectedEvent.tags) || (selectedSchedule && selectedSchedule.tags) || [])
                              .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                                || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                          />
                        </Box>
                        <FormControlLabel
                          sx={{ m: 0 }}
                          value
                          control={(<Radio size="small" />)}
                          label={`All ${eventTasks.length} ${resourceType}s`}
                        />
                        <Box sx={{ ml: 4 }}>
                          <TagList
                            tags={((selectedSchedule && selectedSchedule.tags) || [])
                              .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                                || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                    <Divider sx={{ my: 1 }} />
                  </Box>
                )
                : <Box />
            }
          </DialogContent>
          <DialogActions>
            {
              scheduleSeriesText && (
                <Box>
                  <em>
                    <Typography
                      sx={{
                        p: 2,
                        fontSize: 12,
                      }}
                    >&#42;This {entityTerm} is part of a recurring series of {resourceType}s,{' '}
                      repeating {scheduleSeriesText}.
                    </Typography>
                  </em>
                </Box>
              )
            }
            <Button
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                this.setState({
                  open: false,
                  confirmCancelOccurrence: false,
                  confirmCancelSeries: false,
                  confirmEndSeries: false,
                  dialogType: 'more',
                })
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              size="small"
              sx={{ ml: 2 }}
              loading={(isUpdatingEvent || isFetchingSchedules)}
              disabled={!this.state.confirmCancelOccurrence && !this.state.confirmCancelSeries && !this.state.confirmEndSeries}
              onClick={(e) => {
                e.stopPropagation();
                if (this.state.confirmCancelOccurrence) {
                  this.handleConfirmDeleteOccurrence()
                } else if (this.state.confirmCancelSeries) {
                  this.handleConfirmDeleteSeries();
                } else if (this.state.confirmEndSeries) {
                  this.handleConfirmEndSeries();
                }
              }}
            >
              Confirm Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

EventActionsMenuComponent.propTypes = {
  selectedEvent: PropTypes.object,
  selectedSchedule: PropTypes.object,
  selectedScheduleEvent: PropTypes.object,
  eventTasks: PropTypes.array,

  attachFileClick: PropTypes.func,

  isUpdatingEvent: PropTypes.bool,
  patchEvent: PropTypes.func,

  sx: PropTypes.object,
  changeStatus: PropTypes.func,
  editEventStatus: PropTypes.func,
  addScheduleException: PropTypes.func,
  deleteSchedule: PropTypes.func,
  updateSchedule: PropTypes.func,
  selectedBarn: PropTypes.object,
  setGlobalModals: PropTypes.func,
  modalCallback: PropTypes.func,
  getEvent: PropTypes.func,
  isFetchingSchedules: PropTypes.bool,
  permissions: PropTypes.object,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  editMode: PropTypes.bool,
  flexDirection: PropTypes.string,
  showMore: PropTypes.bool,
};

EventActionsMenuComponent.defaultProps = {
  selectedEvent: null,
  selectedSchedule: null,
  selectedScheduleEvent: null,
  eventTasks: [],

  attachFileClick: null,

  isUpdatingEvent: false,
  isFetchingSchedules: false,

  patchEvent: () => { },
  sx: { color: '#fff' },
  changeStatus: () => { },
  editEventStatus: () => { },
  addScheduleException: () => { },
  deleteSchedule: () => { },
  updateSchedule: () => { },
  getEvent: () => { },
  setGlobalModals: () => { },
  modalCallback: () => { },
  selectedBarn: {},
  permissions: {},
  onClose: () => { },
  onEdit: null,
  editMode: false,
  flexDirection: 'row',
  showMore: false,
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  selectedSchedule: state.schedule.schedule,
  selectedScheduleEvent: state.schedule.event,
  eventTasks: state.schedule.eventTasks,

  isUpdatingEvent: state.event.isUpdatingEvent,
  isFetchingSchedules: state.schedule.isFetchingSchedules,

  canAttachFiles: (state.tenant.tenant && state.tenant.tenant.stripePlan !== null),
  selectedBarn: state.barn.selectedBarn,
  permissions: state.user.permissions,
  modalCallback: state.app.modalCallback,
});

export const mapDispatchToProps = (dispatch) => ({
  patchEvent: (id, request) => dispatch(patchEvent(id, request)),
  changeStatus: (id, request) => dispatch(changeStatus(id, request)),
  editEventStatus: (id, request) => dispatch(editEventStatus(id, request)),
  addScheduleException: (id, request) => dispatch(addScheduleException(id, request)),
  deleteSchedule: (id) => dispatch(deleteSchedule(id)),
  updateSchedule: (id, request) => dispatch(updateSchedule(id, request)),
  getEvent: (id) => dispatch(getEvent(id)),
  setGlobalModals: (t, e, s, ee, c, cc) => dispatch(setGlobalModals(t, e, s, ee, c, cc)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventActionsMenuComponent);
